import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { Bell, TrendingUp, ArrowRight } from "lucide-react";

export const PriceAlerts = () => {
  const { t, lang } = useLang();
  const [alerts, setAlerts] = useState(null);

  useEffect(() => {
    api.get("/valuations/alerts").then((r) => setAlerts(r.data.alerts || [])).catch(() => setAlerts([]));
  }, []);

  if (!alerts) return null;
  const rising = alerts.filter((a) => a.delta_pct >= 1);
  const fmt = (n) => `€${Number(n).toLocaleString(lang === "it" ? "it-IT" : "en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  return (
    <section data-testid="price-alerts" className="mt-10 border border-black">
      <div className="flex items-center gap-2 px-6 py-4 bg-[#0A0A0A] text-white">
        <Bell size={14} className="text-[#FFCC00]" />
        <span className="overline text-white">{t.dashboard.alerts_title}</span>
        {rising.length > 0 && (
          <span data-testid="alerts-count" className="ml-auto bg-[#FFCC00] text-black font-mono text-[10px] font-bold tracking-widest uppercase px-2 py-1">
            {rising.length} {t.dashboard.alerts_up}
          </span>
        )}
      </div>
      {rising.length === 0 ? (
        <p data-testid="alerts-empty" className="px-6 py-5 text-sm text-[#737373]">{t.dashboard.alerts_none}</p>
      ) : (
        <div className="divide-y divide-black/10">
          {rising.map((a) => (
            <div key={a.id} data-testid={`alert-${a.id}`} className="px-6 py-4 flex flex-wrap items-center gap-x-6 gap-y-2 bg-[#FFCC00]/10">
              <div className="min-w-0 flex-1">
                <div className="font-display font-bold leading-tight">{a.brand || "—"} {a.model}</div>
                <div className="font-mono text-[10px] text-[#737373] uppercase tracking-widest mt-0.5">
                  {t.dashboard.alerts_then}: {fmt(a.old_value)} → {t.dashboard.alerts_now}: {fmt(a.current_value)}
                </div>
              </div>
              <span data-testid={`alert-delta-${a.id}`} className="inline-flex items-center gap-1 font-display font-black text-xl tracking-tighter text-[#002FA7]">
                <TrendingUp size={16} /> +{a.delta_pct}%
              </span>
              <span className="inline-flex items-center gap-1 bg-[#0A0A0A] text-white font-mono text-[9px] font-bold tracking-widest uppercase px-2 py-1.5">
                {t.dashboard.alerts_sell} <ArrowRight size={10} />
              </span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default PriceAlerts;
